module.exports = __webpack_public_path__ + "img/16.732576b8.webp";